// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s9Jjcw8oxYEms36Bwwqe{width:85%;padding:1rem;margin:0 auto;white-space:pre-wrap}.s9Jjcw8oxYEms36Bwwqe .TGxgSuQt5RsYXdE3d4Cp{color:#6e32f0;text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.7rem;text-transform:uppercase}.s9Jjcw8oxYEms36Bwwqe .fsuI5hzBssVDsF1uFZrR{text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.2rem;text-transform:uppercase}.s9Jjcw8oxYEms36Bwwqe .bUULt6ED4Sfg8xB50AmL{margin-top:1rem}.s9Jjcw8oxYEms36Bwwqe h3{font-size:14px;margin-top:2rem;margin-bottom:.5rem}.s9Jjcw8oxYEms36Bwwqe p{margin-top:0;margin-bottom:0;font-size:12px}.s9Jjcw8oxYEms36Bwwqe .Az7ZKPN463P0GbWmZPhp{display:flex;justify-content:center;margin-top:2rem;width:100%}.s9Jjcw8oxYEms36Bwwqe .Az7ZKPN463P0GbWmZPhp i{color:#6e32f0 !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"slide4": `s9Jjcw8oxYEms36Bwwqe`,
	"title": `TGxgSuQt5RsYXdE3d4Cp`,
	"subtitle": `fsuI5hzBssVDsF1uFZrR`,
	"description5": `bUULt6ED4Sfg8xB50AmL`,
	"buttonContainer": `Az7ZKPN463P0GbWmZPhp`
};
export default ___CSS_LOADER_EXPORT___;
